import styled from 'styled-components';

export const TooltipWrapper = styled.span`
    align-items: center;
    display: flex;
    gap: 4px;
    // NOTE: this is required because of tooltip icon height
    margin-bottom: -2px;
`;
